import { useContext } from "react";
import { FeedbackContext } from "./FeedbackContextProvider";

const useFeedbackContext = () => useContext(FeedbackContext);

export default useFeedbackContext;
